import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/styles';
import { TextField, Typography } from '@material-ui/core';
import {formatCurrency} from '../hooks/currency'

const useStyles = makeStyles((theme) => ({

  icon:{
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center',
    alignItems: 'center',
    color:theme.palette.icon.main,
  },



  price: {
    margin: theme.spacing(0,0,0,2),
    fontSize: "2rem",
  },

  total: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //marginRight: theme.spacing(3),
    marginBottom: theme.spacing(2)
   },

   change: {
    display: 'flex',
    flexDirection:'column',
    justifyContent: 'flex-end',
    alignItems: 'start',
   
   },

   autocompleteInput: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: "100%",
    border: "none",
    borderRadius: "0.5rem",
    placeHolder: "Address",
    backgroundColor: theme.palette.background.grey,
    paddingLeft: "0.3rem",
    paddingRight: "0.3rem",
    marginTop: "0.5rem",
    marginBottom: "0.3rem",

  },

  inputDetails: {
    width: "100%",
    border: "none",
    paddingTop: "0.7rem",
    paddingBottom: "0.7rem",
    placeHolder: "Address",
    marginLeft: "0.5rem",
    marginRight: "0.5rem",
    backgroundColor: 'disabled',
    outline: 'none',
    fontSize: '1.5rem',
    backgroundColor: theme.palette.background.grey, 
    textAlign:"end",
    autoComplete: "off"
  },

  symbol: {
    margin: theme.spacing(0,1,0,0.5),
    fontSize: "1.5rem",
    color: theme.palette.icon,
    //backgroundColor:'blue'
  },

  action:{
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
   // backgroundColor:'blue'
  },

  continue:{
   paddingRight:theme.spacing(1)
  }


}));




export default function PaymentDialog(props) {
  const classes = useStyles();
  const {open,total,onClose,onContinue,onAccept,title,currency, labelTotal, labelChange,labelAccept, labelContinue} = props; 
  //console.debug("PaymentDialog:");

  const [value, setValue] = useState(0); 
  const [done, setDone] = useState(false); 
  const totalPriceNumber = Number(total); 

  const handleAccept =()=>{
    onAccept(value,formatCurrency(currency,value)); 
  }


  const handlerOnChangeDetails = (event)=>{
    let newValue = Number(event.target.value);
    if(newValue==0) newValue=undefined  
   //event.target.value = newValue;
    setValue(newValue); 
    //console.debug("handlerOnChangeDetails:",newValue);
    
  }


  return (
    <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

   

    

    <DialogContent>

    <div className={classes.total}>
      <Typography variant="body1"> {labelTotal} </Typography>
      <p className={classes.price}> { formatCurrency(currency,total)}</p>
    </div>

    <div className={classes.change}>
          <Typography variant="body1"> {labelChange} </Typography>

           <div className={classes.autocompleteInput}>
                <input 
                  id="detailsId"
                  autoComplete="off"
                  className={classes.inputDetails} 
                  type="number" 
                  placeholder={""}  
                  onChange = {handlerOnChangeDetails}      
                  //autoFocus
                /> 
                { currency.style && currency.style.symbol &&
                <p className={classes.symbol}> {currency.style.symbol}</p>   
                }  
             </div>
    </div>
    </DialogContent>
    
   

    <DialogActions>
    <div className={classes.action}>
      <div className={classes.continue}>
      <Button 
       onClick={onContinue}
       color="accent"
       variant="outlined"      
       >
        {labelContinue}
      </Button>
      </div>
      <Button
       onClick={handleAccept}
       color="accent"
       variant="contained"  
       disableElevation
       disabled={value==undefined || value<totalPriceNumber}   
       >
        {labelAccept}
      </Button>
      </div>
    </DialogActions>
  </Dialog>
  );
}
